import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import trash from '../ProgramViewTestimonial/trash.svg';
import _trim from 'lodash/trim';
import s from './AdditionalInfo.css';

class AdditionalInfo extends React.Component {
  render() {
    if (this.props.role == 'Admin') {
      if (this.props.status == 'view') {
        return (
          <div className={s.wrapper}>
            <div className={s.section}>
              <h2 className={s.header}>Eligibility Requirements</h2>
              <p>{_trim(this.props.eligibility).replace(/(\r\n|\n|\r)/gm, "<br/>")}</p>
            </div>
            <div className={s.section}>
              <h2 className={s.header}>
                Scholarship or Financial Aid Opportunities
              </h2>
              <p>{_trim(this.props.financialAid.scholarship_info).replace(/(\r\n|\n|\r)/gm, "<br/>")}</p>
              {/* <p>Early application discount</p>
          <p>Fund for Education Abroad</p>
          <p>Departmental Scholarship/Grants</p>
          <p className={s.bold}>Pell Grant Matching Awards</p>
          <p>Institutional & Federal Awards</p> */}
            </div>
          </div>
        );
      } else if (this.props.status == 'edit') {
        // Edit Section
        return (
          <div className={s.wrapper}>
            <div className={s.section}>
              <div className={`col-sm-8 ${s.testEdit}`}>
                <h2 className={s.header}>Editing Eligibility Requirements</h2>
                <p>{this.props.eligibility}</p>
              </div>
              <div className={s.trashButton}>
                <img src={trash} />
              </div>
            </div>
            <div className={s.section}>
              <div className={`col-sm-8 ${s.testEdit}`}>
                <h2 className={s.header}>
                  Scholarship or Financial Aid Opportunities
                </h2>
                <p>{this.props.financialAid.scholarship_info}</p>
              </div>
              <div className={s.trashButton}>
                <img src={trash} />
              </div>
              {/* <p>Early application discount</p>
      <p>Fund for Education Abroad</p>
      <p>Departmental Scholarship/Grants</p>
      <p className={s.bold}>Pell Grant Matching Awards</p>
      <p>Institutional & Federal Awards</p> */}
            </div>
          </div>
        );
      }
    } else {
      return (
        <div className={s.wrapper}>
          {this.props.eligibility ? (
            <div className={s.section}>
              <h2 className={s.header}>Eligibility Requirements</h2>
              <p>{this.props.eligibility}</p>
            </div>
          ) : (
            ''
          )}
          {this.props.financialAid.scholarship_info ? (
            <div className={s.section}>
              <h2 className={s.header}>
                Scholarship or Financial Aid Opportunities
              </h2>
              <p>{this.props.financialAid.scholarship_info}</p>
              {/* <p>Early application discount</p>
          <p>Fund for Education Abroad</p>
          <p>Departmental Scholarship/Grants</p>
          <p className={s.bold}>Pell Grant Matching Awards</p>
          <p>Institutional & Federal Awards</p> */}
            </div>
          ) : (
            ''
          )}
        </div>
      );
    }
  }
}

export default withStyles(s)(AdditionalInfo);
